module.exports = __webpack_public_path__ + "static/media/Madagascar.50f45ceb.png";